import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FastImage from 'react-native-fast-image';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import {css} from 'styled-components/native';

interface Check {
  check?: boolean;
}

export const Container = styled.View`
  width: 100%;
`;

export const PaymentTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  margin-left: ${RFValue(12)}px;
`;

export const PaymentInfo = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
`;

export const Payment = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BrandContainer = styled.View`
  width: ${RFValue(35)}px;
  height: ${RFValue(35)}px;
  align-items: center;
  border: 2px solid ${({theme}) => theme.colors.border3};
  border-radius: ${RFValue(10)}px;
  justify-content: center;
`;

//@ts-ignore
export const BrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
`;

export const PaymentMethodInfo = styled.View`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CheckIcon = styled(FontAwesome5)<Check>`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.placeholder};

  ${({check, theme}) =>
    check &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const PromoCard = styled.Text`
  font-size: ${RFValue(9)}px;
  background-color: ${({theme}) => theme.colors.brbButton};
  color: ${({theme}) => theme.colors.shape};
  padding:0 4px;
  border-radius: 5px;
  overflow: hidden;
  font-family: ${({theme}) => theme.fonts.bold};
   margin-left: ${RFValue(12)}px;
`;

export const InstallmentsContainer = styled.View`

  border-bottom-width: 1px;
  border-top-width: 1px;
  border-style: solid;
  background-color: ${({theme} ) => theme.colors.background_black};
  border-color: ${({theme}) => theme.colors.border};
  padding: ${RFValue(10)}px 24px;
  padding-left:  48px;
  margin:0 -24px;
 margin-bottom: ${RFValue(12)}px;
`;

export const InstallmentHintContainer = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const InstallmentHintTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
`;

export const InstallmentHintSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(11)}px;
`;

export const Divider = styled.View`
  height: ${RFValue(1)}px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(12)}px 0;
`;

export const EmptyContainer = styled.View`
  align-items: center;
  justify-content: center;
  padding: ${RFValue(24)}px ${RFValue(16)}px;
  gap: ${RFValue(8)}px;
`;

export const EmptyIconWrapper = styled.View`
  width: ${RFValue(52)}px;
  height: ${RFValue(52)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.border};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const EmptyIcon = styled(FontAwesome5)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.placeholder};
`;

export const EmptyTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
  text-align: center;
`;

export const EmptySubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(11)}px;
  text-align: center;
`;
